import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { MarketplaceComponent } from './marketplace/marketplace.component'
import { ProductDetailComponent } from './product-detail/product-detail.component'
import { SeoResolver } from '../../seo.resolver'

const routes: Routes = [
  {
    path: '',
    component: MarketplaceComponent,
    data: {
      meta: {
        title: 'marketplace.meta.title',
        description: 'marketplace.meta.description',
        robots: 'index,follow',
      },
    },
    resolve: {
      meta: SeoResolver,
    },
  },
  {
    path: ':id/:name',
    component: ProductDetailComponent,
    data: {
      breadcrumb: 'Product Detail',
      robots: 'index,follow',
    },
    resolve: {
      meta: SeoResolver,
    },
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [SeoResolver],
})
export class MarketRoutingModule {}
